import React, { useEffect, useState } from 'react';
import backicon from "../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API';

const ViewQuotationList = () => {

  const [ physicalStockTakingList, setPhysicalStockTakingList ] = useState([])
  const [ formData, setFormData ] = useState([])
  const [ stockTypesData, setStockTypesData ] = useState([])
const navigate = useNavigate()

  const [ businessPartnerIdState, setBusinessPartnerIdState ] = useState(null)
// const [PhysicalStockinId,setPhysicalStockinId] = useState(0)
  const token = localStorage.getItem("authToken");
  const [vendorId,setVendorId] = useState()

  const location = useLocation();
  const { data } = location.state || {};
const PhysicalStockinId = data?.phystkin_id
  console.log("locationdata<><><>",data);
  

  useEffect(() => {
    fetchPhysicalStockTakingListEdit()
  },[])

  
  const fetchPhysicalStockTakingListEdit = async () => {
    try{
      const response = await axiosInstance.post(`/quotation/getquotationview`,{
        business_partner_id: 1,
        quotation_id:data.quotation_id
      }, {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    })
    const fetchedData = response?.data?.data[0]
   
    console.log(fetchedData, "FETCHEDDATA")
    setPhysicalStockTakingList(fetchedData)
  
  }catch(error){
      console.log(error)
    }
  }

  // const handleApprove = async () => {
  //   // SweetAlert confirmation before approval
  //   showCustomAlert({
  //     title: "Success",
  //     text: "Do you want to approve this quotation?",
  //     icon: "success",
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "No",
  //     callback: async () => {
  //       try {
  //         const payload = {
  //           discount_approval: 1,
  //           approval_remark:"",
  //           business_partner_id:1,
  //           quotation_id: data.quotation_id
  //         };
  
  //         // API request to approve purchase order
  //         const response = await axiosInstance.patch(
  //           `/quotationapproval/updatequotationapprovals/${data.quotation_id}`,
  //           payload,
  //           {
  //             headers: {
  //               "Content-Type": "application/json",
  //               Authorization: `Bearer ${token}`,
  //             },
  //           }
  //         );
  
  //         // Success action if approval is successful
  //         if (response.status === 200) {
  //           navigate(ROUTES_NAVIGATION.POAPPROVAL);
  //           console.log(response, "RESPONSE");
  //         }
  //       } catch (error) {
  //         console.log(error, "error");
  
  //         const errorMessage = error.response?.data?.message

  //     showErrorAlert({
  //       title: "Something went wrong",
  //       text: errorMessage || "An error occurred while processing your request.",
  //       callback: () => { 
  //         // Optional: code to execute after confirming the alert
  //         console.log("Error alert confirmed");
  //       }
  //     });
  //       }
  //     },
  //   });
  // };

  return (
    <div>
      <div className="" >
        <div style={{paddingBottom:"35px", borderBottom:"1px solid lightgray", padding:"35px"}}>
      <span style={{fontWeight:"300", fontSize:"12px", paddingBottom:"5px", color:"gray", paddingLeft:"15px"}}>Sales / Quotations / Quotation Details</span>
      {/* <div style={{display:"flex",alignItems:"center"}}> */}
      <div className="backbutton" onClick={()=>navigate("/manage-sales/quotation-approval")} >
        <img src={backicon} alt="back" />
          <span className="backbtntitleDetails"> Quotation Details</span>   
      </div>
      {/* <button
              className="flte-btn"
              style={{ padding: "12px 18px", borderRadius: "38px" }}
              // onClick={handleApprove}
            >
              Approve
            </button> */}
      {/* </div> */}
        </div>
        
        <div >
        <div className="" >
        <h5 style={{paddingLeft:"55px"}} className='mt-2 mb-2 header-details'>Personal Details</h5>
          <div className="detail-grid" style={{ paddingBottom:"30px", borderBottom:"1px solid lightgray", paddingLeft:"57px", paddingTop:"15px"}}>
            <div className="details-item">
              <span className="details-label">Lead Id</span>
              <span className="details-value"> {physicalStockTakingList.lead_code} </span>
             
            </div>
            <div className="details-item">
              <span className="details-label">Customer Name</span>
              <span className="details-value">{physicalStockTakingList.customer_name} </span>
              
            </div>
            <div className="details-item">
              <span className="details-label">Contact No.</span>
              <span className="details-value">{physicalStockTakingList.mobile_no} </span>
              
            </div>
            <div className="details-item">
              <span className="details-label">Transaction Code</span>
              <span className="details-value"> {physicalStockTakingList.transaction_code} </span>
             
            </div>
            <div className="details-item">
              <span className="details-label">Quotation Date</span>
              {new Date(physicalStockTakingList.quotation_date).toLocaleDateString('en-GB', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            }).replace(/\//g, '-')}
            </div>

            <div className="details-item">
              <span className="details-label">Dealer Branch</span>
              <span className="details-value">{physicalStockTakingList.showroom_name} </span>
            </div>

            <div className="details-item">
              <span className="details-label">Sales Person</span>
              <span className="details-value">{physicalStockTakingList.salesperson_name} </span>
            </div>
            <div className="details-item">
              <span className="details-label">Address</span>
              <span className="details-value">{physicalStockTakingList.address} </span>
            </div>

            <div className="details-item">
              <span className="details-label">PIN Code</span>
              <span className="details-value">{physicalStockTakingList.pincode} </span>
            </div>

            <div className="details-item">
              <span className="details-label">City</span>
              <span className="details-value">{physicalStockTakingList.city_name} </span>
            </div>

            <div className="details-item">
              <span className="details-label">State</span>
              <span className="details-value">{physicalStockTakingList.state_name} </span>
            </div>

          </div>

        </div>
        </div>

        {/* ------------------------ */}
        <div >
        <div className="" >
        <h5 style={{paddingLeft:"55px"}} className='mt-2 mb-2 header-details'>Vehicle Details</h5>
          <div className="detail-grid" style={{ paddingBottom:"30px", borderBottom:"1px solid lightgray", paddingLeft:"57px", paddingTop:"15px"}}>
            <div className="details-item">
              <span className="details-label">Product Name</span>
              <span className="details-value">{physicalStockTakingList.product_name} </span>
             
            </div>
            <div className="details-item">
              <span className="details-label">Sub Product Name</span>
              <span className="details-value">{physicalStockTakingList.subproduct_name} </span>
              
            </div>
            <div className="details-item">
              <span className="details-label">Make</span>
              <span className="details-value">{physicalStockTakingList.make_name} </span>
              
            </div>
            <div className="details-item">
              <span className="details-label">Model</span>
              <span className="details-value">{physicalStockTakingList.model_name} </span>
             
            </div>
            <div className="details-item">
              <span className="details-label">Variant</span>
              <span className="details-value"> Variant</span>
            </div>

            <div className="details-item">
              <span className="details-label">Variant Color</span>
              <span className="details-value">{physicalStockTakingList.color_name} </span>
            </div>

            <div className="details-item">
              <span className="details-label">Fuel Type</span>
              <span className="details-value">{physicalStockTakingList.fuel_type_name} </span>
            </div>

          </div>

        </div>
        </div>

      {/* --------------------- */}
      <div >
        <div className="" >
        <h5 style={{paddingLeft:"55px"}} className='mt-2 mb-2 header-details'>Quotation Details</h5>
          <div className="detail-grid" style={{ paddingBottom:"30px", borderBottom:"1px solid lightgray", paddingLeft:"57px", paddingTop:"15px"}}>
            <div className="details-item">
              <span className="details-label">Ex Showroom Price</span>
              <span className="details-value">{physicalStockTakingList.exshowroomprice}  </span>
             
            </div>
            <div className="details-item">
              <span className="details-label">Plate Charges</span>
              <span className="details-value">{physicalStockTakingList.platecharges} </span>
              
            </div>
            <div className="details-item">
              <span className="details-label">Insurance</span>
              <span className="details-value">{physicalStockTakingList.insurance} </span>
              
            </div>
            <div className="details-item">
              <span className="details-label">RTO Amount</span>
              <span className="details-value">{physicalStockTakingList.rto_amount} </span>
             
            </div>
            <div className="details-item">
              <span className="details-label">Accessories Cost</span>
              <span className="details-value">{physicalStockTakingList.accessory_cost} </span>
            </div>

            <div className="details-item">
              <span className="details-label">Discount Type</span>
              <span className="details-value">{physicalStockTakingList.discounttype} </span>
            </div>

            <div className="details-item">
              <span className="details-label">Discount Amount</span>
              <span className="details-value">{physicalStockTakingList.discount} </span>
            </div>

            {/* <div className="details-item">
              <span className="details-label">Tax set</span>
              <span className="details-value">{physicalStockTakingList.} </span>
            </div> */}

            <div className="details-item">
              <span className="details-label">Tax amount</span>
              <span className="details-value">{physicalStockTakingList.taxamount} </span>
            </div>

            <div className="details-item">
              <span className="details-label">On Road Price</span>
              <span className="details-value">{[physicalStockTakingList.onroadprice]} </span>
            </div>

            

          </div>

        </div>
        </div>

        {/* --------------------- */}
        <div >
        <div className="" >
        <h5 style={{paddingLeft:"55px"}} className='mt-2 mb-2 header-details'>Finance Details</h5>
          <div className="detail-grid" style={{ paddingBottom:"30px", borderBottom:"1px solid lightgray", paddingLeft:"57px", paddingTop:"15px"}}>
            <div className="details-item">
              <span className="details-label">Payable Amount</span>
              <span className="details-value"> {physicalStockTakingList.balance_amount} </span>
             
            </div>
            <div className="details-item">
              <span className="details-label">Quotation Status</span>
              <span className="details-value">{physicalStockTakingList.quotation_status} </span>
              
            </div>
            

          </div>

        </div>
        </div>

      </div>
    </div>
  )
}

export default ViewQuotationList;